import React from "react";
import { Helmet } from "react-helmet";
import ReactWhatsapp from "react-whatsapp";

function Testing() {
  return (
    <div>
      <Helmet>
        <title>Fire Safety Equipment  Testing | Make Your Workplace Safe</title>
        <link
          rel="canonical"
          href="https://www.therapidhire.com/testing"
          data-react-helmet="true"
        ></link>

        <meta
          name="description"
          content="Testing is important to evaluate the healthiness of the installed fire protection system so that it can work properly in case of an emergency."
        />

        <meta
          name="keyword"
          content=" lab test laboratory test testing lab services standard laboratory tests"
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:1, max-video-preview:1"
        />

        <meta
          name="fb:app_id"
          content="1369882117133030"
          data-react-helmet="true"
        />
        <meta
          property="og:url"
          content="https://www.therapidhire.com/testing"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Fire Safety Equipment  Testing | Make Your Workplace Safe"
        />
        <meta
          property="og:description"
          content="Testing is important to evaluate the healthiness of the installed fire protection system."
        />
        <meta
          property="og:image"
          content="https://www.therapidhire.com/images/Firesafety2.jpg"
        />
        <meta property="og:image:type" content="image/jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="fire safety" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@therapidhire_" />
        <meta
          property="twitter:url"
          content="https://www.therapidhire.com/testing"
        />
        <meta
          name="twitter:title"
          content="Fire Safety Equipment Testing"
        />
        <meta
          name="twitter:description"
          content="Testing is important to evaluate the healthiness of the installed fire protection system."
        />
        <meta
          name="twitter:image"
          content="https://www.therapidhire.com/images/Firesafety2.jpg"
        />
      </Helmet>
      <div
        id="rs-slider"
        className="rs-slider slider3 rs-slider-style3"
        style={{ position: "relative", overflow: "hidden" }}
      >
        <div className="bend niceties">
          <img src="images/Firesafety2.jpg" alt="firesafety" title="" />
        </div>
      </div>
      <p className="text-center container fs-3 pt-5">
        <strong
          className="text-center font-weight-normal"
          style={{ fontWeight: "500" }}
        >
          "Testing is important to evaluate the healthiness of the installed
          fire protection system so that they can work properly in case of an
          emergency "
        </strong>
      </p>
      <div
        id="carouselMultiItemExample"
        class="carousel slide carousel-dark text-center"
        data-mdb-ride="carousel"
      >
        <div class="d-flex justify-content-center mb-4">
          <button
            class="carousel-control-prev position-relative"
            type="button"
            data-mdb-target="#carouselMultiItemExample"
            data-mdb-slide="prev"
          >
            <span class="" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next position-relative"
            type="button"
            data-mdb-target="#carouselMultiItemExample"
            data-mdb-slide="next"
          >
            <span class="" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
        <div class="carousel-inner py-4">
          <div class="carousel-item active">
            <div class="container">
              <div class="row">
                <div class="col-lg-4">
                  <div class="card">
                    <img
                      src="images/Pumptest.png"
                      class="card-img-top"
                      alt="pumptest"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Pump house Testing</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="card">
                    <img
                      src="images/Alarm.png"
                      class="card-img-top"
                      alt="Alarm"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Fire Detection & Alarm System</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="card">
                    <img
                      src="images/Sprinkler.png"
                      class="card-img-top"
                      alt="Sprinkler"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Sprinkler System Testing</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="carousel-item">
            <div class="container">
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <div class="card">
                    <img
                      src="images/Supperation.png"
                      class="card-img-top"
                      alt="Supperation"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Suppression System Testing</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 d-none d-lg-block">
                  <div class="card">
                    <img
                      src="images/Supperation.png"
                      class="card-img-top"
                      alt="Supperation"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Card title</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 d-none d-lg-block">
                  <div class="card">
                    <img
                      src="https://mdbcdn.b-cdn.net/img/new/standard/nature/186.webp"
                      class="card-img-top"
                      alt="Hot Air Balloons"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Card title</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="carousel-item">
            <div class="container">
              <div class="row">
                <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
                  <div class="card">
                    <img
                      src="https://mdbcdn.b-cdn.net/img/new/standard/nature/187.webp"
                      class="card-img-top"
                      alt="Peaks Against the Starry Sky"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Card title</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                  <div class="card">
                    <img
                      src="https://mdbcdn.b-cdn.net/img/new/standard/nature/188.webp"
                      class="card-img-top"
                      alt="Bridge Over Water"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Card title</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                  <div class="card">
                    <img
                      src="https://mdbcdn.b-cdn.net/img/new/standard/nature/189.webp"
                      class="card-img-top"
                      alt="Purbeck Heritage Coast"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Card title</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="carouselMultiItemExample"
        class="carousel slide carousel-dark text-center"
        data-mdb-ride="carousel"
      >
        <div class="d-flex justify-content-center mb-4">
          <button
            class="carousel-control-prev position-relative"
            type="button"
            data-mdb-target="#carouselMultiItemExample"
            data-mdb-slide="prev"
          >
            <span class="" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next position-relative"
            type="button"
            data-mdb-target="#carouselMultiItemExample"
            data-mdb-slide="next"
          >
            <span class="" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
        <div class="carousel-inner py-4">
          <div class="carousel-item active">
            <div class="container">
              <div class="row">
                <div class="col-lg-4">
                  <div class="card">
                    <img
                      src="images/Supperation.png"
                      class="card-img-top"
                      alt="Supperation"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Suppression System Testing</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="card">
                    <img
                      src="images/hydrant.png"
                      class="card-img-top"
                      alt="hydrant"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Fire Hydrant System</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="card">
                    <img
                      src="images/Annual.png"
                      class="card-img-top"
                      alt="Annual"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Annual Performance Testing</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="carousel-item">
            <div class="container">
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <div class="card">
                    <img
                      src="https://mdbcdn.b-cdn.net/img/new/standard/nature/184.webp"
                      class="card-img-top"
                      alt="Fissure in Sandstone"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Card title</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 d-none d-lg-block">
                  <div class="card">
                    <img
                      src="https://mdbcdn.b-cdn.net/img/new/standard/nature/185.webp"
                      class="card-img-top"
                      alt="Storm Clouds"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Card title</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 d-none d-lg-block">
                  <div class="card">
                    <img
                      src="https://mdbcdn.b-cdn.net/img/new/standard/nature/186.webp"
                      class="card-img-top"
                      alt="Hot Air Balloons"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Card title</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="carousel-item">
            <div class="container">
              <div class="row">
                <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
                  <div class="card">
                    <img
                      src="https://mdbcdn.b-cdn.net/img/new/standard/nature/187.webp"
                      class="card-img-top"
                      alt="Peaks Against the Starry Sky"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Card title</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                  <div class="card">
                    <img
                      src="https://mdbcdn.b-cdn.net/img/new/standard/nature/188.webp"
                      class="card-img-top"
                      alt="Bridge Over Water"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Card title</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                  <div class="card">
                    <img
                      src="https://mdbcdn.b-cdn.net/img/new/standard/nature/189.webp"
                      class="card-img-top"
                      alt="Purbeck Heritage Coast"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Card title</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="text-center container pt-5">
        <strong className="text-center fs-4" style={{ fontWeight: "500" }}>
          We provide services in the field of testing of fire Protection system
          and fire detection system as per the defined standards.
        </strong>
      </p>
      <div class="floating_btn">
        <a target="_blank" href="https://wa.me/">
          <div class="contact_icon">
            <ReactWhatsapp
              number="+91-9907657026"
              message="Hello, May I Help You !"
              class="whatsappbuttn"
            >
              {" "}
              <i className="fa fa-whatsapp"></i>
            </ReactWhatsapp>
          </div>
        </a>
        <p class="text_icon">Chat with us</p>
      </div>
    </div>
  );
}

export default Testing;
